import React, { useState } from 'react';
import axios from 'axios';
import { FiRefreshCw } from 'react-icons/fi';
import Lottie from 'lottie-react';
import { AnimatePresence, motion } from 'framer-motion';
import logoPilari from '../assets/images/pilari_dark.png';
import rocketLaunchAnim from '../assets/lottie/rocket.json';

const LaunchButtonPage = () => {
  const [isTriggered, setIsTriggered] = useState(false);
  const [error, setError] = useState(null);
  const [progress, setProgress] = useState(0);
  const [showLottie, setShowLottie] = useState(false);
  const [isDone, setIsDone] = useState(false);

  const handleTriggerLaunch = async () => {
    try {
      await axios.post('https://pilari.app/api/launch/trigger');
      setIsTriggered(true);
      setError(null);
      setProgress(0);
      setShowLottie(false);
      setIsDone(false);

      let current = 0;
      const interval = setInterval(() => {
        current += 1;
        setProgress(current);
        if (current >= 100) {
          clearInterval(interval);
          setShowLottie(true);
          setTimeout(() => {
            setShowLottie(false);
            setIsDone(true);
          }, 3000);
        }
      }, 100);
    } catch (err) {
      setError('Gagal trigger launching. Silakan coba lagi.');
    }
  };

  const handleReset = async () => {
    try {
      await axios.post('https://pilari.app/api/launch/reset');
      setIsTriggered(false);
      setProgress(0);
      setShowLottie(false);
      setIsDone(false);
      setError(null);
    } catch (err) {
      console.error(err);
      alert('Gagal reset countdown.');
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-violet-100 to-white px-4">
      <AnimatePresence mode="wait">
        {!isDone && !showLottie && (
          <motion.div
            key="initial"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="flex flex-col items-center"
          >
            <img src={logoPilari} alt="Logo PILARI" className="w-36 sm:w-44 mb-10" />

            <button
              onClick={handleTriggerLaunch}
              disabled={isTriggered}
              className={`mb-5 h-16 px-8 text-lg sm:text-xl rounded-full shadow-xl font-semibold tracking-wide transition-all duration-300 flex items-center justify-center whitespace-nowrap ${
                isTriggered
                  ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                  : 'bg-[#7a75b5] text-white hover:bg-[#6a64a1]'
              }`}
            >
              {isTriggered ? (
                progress < 100 ? (
                  <div className="w-48 h-3 bg-gray-200 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-[#7a75b5] rounded-full transition-all duration-100"
                      style={{ width: `${progress}%` }}
                    ></div>
                  </div>
                ) : null
              ) : (
                <span className="px-2">🚀 Luncurkan Sekarang</span>
              )}
            </button>

            {error && (
              <div className="mt-4 text-sm text-red-600 bg-red-100 px-4 py-2 rounded-md shadow-sm">
                {error}
              </div>
            )}
          </motion.div>
        )}

        {showLottie && (
          <motion.div
            key="lottie"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="w-[300px] h-[300px]"
          >
            <Lottie
              animationData={rocketLaunchAnim}
              loop={false}
              className="w-full h-full"
            />
          </motion.div>
        )}

        {isDone && (
          <motion.div
            key="done"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="flex flex-col items-center"
          >
            <img src={logoPilari} alt="Logo PILARI" className="w-36 sm:w-44 mb-10" />
            <button
              disabled
              className="mb-5 h-16 px-8 text-lg sm:text-xl rounded-full shadow-xl font-semibold tracking-wide transition-all duration-300 flex items-center justify-center whitespace-nowrap bg-gray-300 text-gray-500 cursor-not-allowed"
            >
              🚀 Peluncuran Selesai
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      <button
        onClick={handleReset}
        title="Reset Countdown"
        className="mt-6 w-12 h-12 rounded-full bg-white border border-gray-300 text-gray-600 hover:bg-gray-100 hover:text-black shadow transition-all flex items-center justify-center text-xl"
      >
        <FiRefreshCw />
      </button>
    </div>
  );
};

export default LaunchButtonPage;
